import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useIncomeOutcomeReport } from '../../hooks/useIncomeOutcomeReport';
import { TransactionReportHeader } from '../transactions/TransactionReportHeader';
import { TransactionStatsCards } from '../transactions/TransactionStatsCards';
import { TransactionFilters } from '../transactions/TransactionFilters';
import { TransactionTable } from '../transactions/TransactionTable';
import { TransactionPagination } from '../transactions/TransactionPagination';
import { MethodTotalsCard } from '../transactions/MethodTotalsCard';
import { UserTotalsCard } from '../transactions/UserTotalsCard';
import { CategoryTotalsCard } from '../transactions/CategoryTotalsCard';

export const IncomeOutcomeReport = () => {
  const { t } = useTranslation();
  const [showPrintModal, setShowPrintModal] = useState(false);
  const [isPrinting, setIsPrinting] = useState(false);

  const {
    paginatedTransactions,
    stats,
    methodTotals,
    userTotals,
    categoryTotals,
    uniqueUsers,
    uniquePaymentMethods,
    uniqueCategories,
    uniqueUnits,

    isLoading,
    isExporting,

    filters,
    sortBy,
    sortOrder,
    currentPage,
    totalPages,
    itemsPerPage,
    activeQuickFilter,
    showAdvancedFilters,
    hasActiveFilters,

    handleRefresh,
    handleExport,
    handleSort,
    handleQuickDateFilter,
    handleUpdateFilter,
    handleClearFilters,
    handlePageChange,
    setShowAdvancedFilters,
    allTransactions
  } = useIncomeOutcomeReport();

  const handlePrintSummary = () => {
    setShowPrintModal(true);
  };

  // if (isLoading) {
  //   return (
  //     <div className="lg:[margin-inline-start:16rem] p-4 lg:p-8 pb-32 lg:pb-8">
  //       <div className="flex items-center justify-center py-12">
  //         <div className="text-center">
  //           <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
  //           <h3 className="text-lg font-medium text-slate-900 mb-2">
  //             {t('Loading data...')}
  //           </h3>
  //         </div>
  //       </div>
  //     </div>
  //   );
  // }

  return (
    <div className="bg-babyblue-50 big-card container-fluid">
      <div className="pt-4 pb-3 px-2 mx-3">
        <TransactionReportHeader
          onRefresh={handleRefresh}
          onExport={handleExport}
          onPrintSummary={handlePrintSummary}
          isLoading={isLoading}
          isExporting={isExporting}
          isPrinting={isPrinting}
        />

        <TransactionStatsCards stats={stats} />

        <TransactionFilters
          filters={filters}
          onFilterChange={handleUpdateFilter}
          onClearFilters={handleClearFilters}
          onQuickDateFilter={handleQuickDateFilter}
          activeQuickFilter={activeQuickFilter}
          showAdvancedFilters={showAdvancedFilters}
          onToggleAdvancedFilters={() => setShowAdvancedFilters(!showAdvancedFilters)}
          hasActiveFilters={hasActiveFilters}
          uniqueUsers={uniqueUsers}
          uniquePaymentMethods={uniquePaymentMethods}
          uniqueCategories={uniqueCategories}
          isLoading={isLoading}
          uniqueUnits={uniqueUnits}
        />

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-6">
          <MethodTotalsCard methodTotals={methodTotals} />
          <UserTotalsCard userTotals={userTotals} />
          <CategoryTotalsCard categoryTotals={categoryTotals} />
        </div>

        {allTransactions.length === 0 ? (
          <div className="bg-white rounded-xl border border-slate-200 p-12 text-center">
            <h3 className="text-lg font-medium text-slate-900 mb-2">
              {hasActiveFilters
                ? t('No Matching Transactions')
                : t('No Transactions')
              }
            </h3>
            <p className="text-slate-500">
              {hasActiveFilters
                ? t('Try adjusting your filters')
                : t('No data to display')
              }
            </p>
            {hasActiveFilters && (
              <button
                onClick={handleClearFilters}
                className="mt-4 px-4 py-2 text-blue-600 hover:bg-blue-50 rounded-lg transition-colors duration-200"
              >
                {t('Clear Filters')}
              </button>
            )}
          </div>
        ) : (
          <>
            <TransactionTable
              transactions={paginatedTransactions}
              sortBy={sortBy}
              sortOrder={sortOrder}
              onSort={handleSort}
            />

            <TransactionPagination
              currentPage={currentPage}
              totalPages={totalPages}
              totalItems={allTransactions.length}
              itemsPerPage={itemsPerPage}
              onPageChange={handlePageChange}
            />
          </>
        )}
      </div>
    </div>
  );
};
